import {BaseApi, BaseApiV2} from "@newview/infrastructure";
export abstract class NewviewWebsiteBaseApi extends BaseApiV2 {
    public get ProxyName(): any {
        return 'NewviewWebsiteBaseApi';
    }
  
}